<template>
  <div class="post-header">
    <post-user-icon :icon="post.author_logo"/>
    {{ post.user }}
    <div class="post-header__author">
      {{ post.author }}
      <span class="post-header__author-date">
         {{ post.created_date }}
      </span>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import PostCounters from './postCounters.vue';
import PostUserIcon from './postUserIcon.vue';

export default {
  name: 'postHeader',
  components: { PostUserIcon, PostCounters },
  props: {
    post: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style lang="stylus">
.post
  width 100%
  &-header
    display flex
    &__user-name
      margin 0 1em
      font-style: normal;
      font-weight: 500;
      font-size: 11px;
      line-height: normal;
      color #000000
    &__counters
      display flex
      align-items center
      margin-left auto
  &-counter
    display flex
    &__icon
      margin-left .8em
      flex-shrink 0
    &__count
      margin-left .3em

.post-header__author {
  display flex
  flex-direction column
  margin-left 15px;
}

.post-header__author-date {
  margin-top 5px;
  font-style: normal;
  font-weight: 500;
  font-size: 9px;
  line-height: normal;
  color: #55626F;
}

.post-header .to-original {
  margin-left auto
}
</style>
